import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { MatDialog } from "@angular/material/dialog";
import { MatOption } from '@angular/material/core';

//SERVICIOS
import { LicenciaService } from 'src/app/services/licencia.service';

@Component({
  selector: 'app-renovar-licencia',
  templateUrl: './renovar-licencia.component.html',
  styleUrls: ['./renovar-licencia.component.scss']
})
export class RenovarLicenciaComponent implements OnInit {

  licencia: any

  constructor(private formBuilder: FormBuilder, private apollo: Apollo,
    public dialog: MatDialog, private licenciaService: LicenciaService) { }

  ngOnInit(): void {
    this.licencia = this.licenciaService.getLicencia()
    console.log(this.licencia);
    
  }

}
